import CONSTANTS from './vars/CONSTANTS';

export default function getLocalWishlist() {
  const wishlist = localStorage.getItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist ? wishlist.split(CONSTANTS.LOCAL_STORAGE_DELIMITER) : [];
}
